/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { Button, Segment, Table, TextArea } from "semantic-ui-react";
import StringEntry from "../../datatypeComponents/StringEntry";
import PositiveIntEntry from "../../datatypeComponents/PositiveIntEntry";
import UnsignedIntEntry from "../../datatypeComponents/UnsignedIntEntry";
import DecimalEntry from "../../datatypeComponents/DecimalEntry";
import CodeEntry from "../../datatypeComponents/CodeEntry";
import { useNavigate } from "react-router-dom";
import { changeFoiFocus } from "../../slices/foiOfFocus/foiOfFocusSlice";
import CodeableConceptEntry from "../../datatypeComponents/CodeableConceptEntry";
import BooleanEntry from "../../datatypeComponents/BooleanEntry";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry";
import MarkdownEntry from "../../datatypeComponents/MarkdownEntry";
import { submitComparativeEvidenceSynthesisReportData } from "../../functions/submitNewComparativeAPI";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import { systemChoices } from "../PicoClassifierModal";

const overallCertaintyRatingValueSet = [
    {
        "coding": [{
            "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
            "code": "high",
            "display": "High quality"
        }]
    },
    {
        "coding": [
            {
                "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
                "code": "moderate",
                "display": "Moderate quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
                "code": "low",
                "display": "Low quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://terminology.hl7.org/CodeSystem/certainty-rating",
                "code": "very-low",
                "display": "Very low quality"
            }
        ]
    }
];

const submitResources = async (apiToken, navigate, tableState, groupReferencesState, dispatch, introductionState, picoClassifiersState) => {

    let response = await submitComparativeEvidenceSynthesisReportData(apiToken, tableState, groupReferencesState, introductionState, picoClassifiersState);
    if (response) {
        if (response.success && response.compositionFOI) {
            if (response.message) {
                alert("A ComparativeEvidenceSyntehsisReport was created but ..." + response.message);
            }
            navigate("/resources/Composition/" + response.compositionFOI);
            dispatch(changeFoiFocus(response.compositionFOI.toString()));
        } else {
            if (response.message) {
                alert(response.message);
            } else {
                alert("Failed response from server.");
            }
        }
    } else {
        alert("No response from server.");
    }
};

const TableRowEntry = ({ row, setTableState, rowIndex }) => {

    const [tableRowState, setTableRowState] = useState({});

    useEffect(() => {
        let startingRow = {
            "outcomeName": "",
            "desirable": false,
            "DIO": false,
            "observedOutcomeReference": "",
            "intendedOutcomeReference": "",
            "numberAffectedIntervention": NaN,
            "numberAnalyzedIntervention": NaN,
            "riskWithIntervention": NaN,
            "numberAffectedComparator": NaN,
            "numberAnalyzedComparator": NaN,
            "riskWithComparator": NaN,
            "effectEstimateType": "",
            "effectEstimateValue": NaN,
            "lowerCI": NaN,
            "upperCI": NaN,
            "certainty": ""
        };
        if (row.outcomeName) {
            startingRow.outcomeName = row.outcomeName;
        }
        if (row.desirable) {
            startingRow.desirable = row.desirable;
        }
        if (row.DIO) {
            startingRow.DIO = row.DIO;
        }
        if (row.observedOutcomeReference) {
            startingRow.observedOutcomeReference = row.observedOutcomeReference;
        }
        if (row.intendedOutcomeReference) {
            startingRow.intendedOutcomeReference = row.intendedOutcomeReference;
        }
        if (row.effectEstimateType) {
            startingRow.effectEstimateType = row.effectEstimateType;
        }
        if (!isNaN(row.numberAffectedIntervention)) {
            startingRow.numberAffectedIntervention = row.numberAffectedIntervention;
        }
        if (!isNaN(row.numberAnalyzedIntervention)) {
            startingRow.numberAnalyzedIntervention = row.numberAnalyzedIntervention;
        }
        if (!isNaN(row.riskWithIntervention)) {
            startingRow.riskWithIntervention = row.riskWithIntervention;
        }
        if (!isNaN(row.numberAffectedComparator)) {
            startingRow.numberAffectedComparator = row.numberAffectedComparator;
        }
        if (!isNaN(row.numberAnalyzedComparator)) {
            startingRow.numberAnalyzedComparator = row.numberAnalyzedComparator;
        }
        if (!isNaN(row.riskWithComparator)) {
            startingRow.riskWithComparator = row.riskWithComparator;
        }
        if (!isNaN(row.effectEstimateValue)) {
            startingRow.effectEstimateValue = row.effectEstimateValue;
        }
        if (!isNaN(row.lowerCI)) {
            startingRow.lowerCI = row.lowerCI;
        }
        if (!isNaN(row.upperCI)) {
            startingRow.upperCI = row.upperCI;
        }
        if (row.certainty) {
            startingRow.certainty = row.certainty;
        }
        setTableRowState(startingRow);
    }, []);

    useEffect(() => {
        if (!isNaN(tableRowState.numberAffectedIntervention) &&
            !isNaN(tableRowState.numberAnalyzedIntervention)) {
            let riskWithIntervention = tableRowState.numberAffectedIntervention / tableRowState.numberAnalyzedIntervention;
            if (!isNaN(riskWithIntervention)) {
                riskWithIntervention = parseFloat((riskWithIntervention * 100).toFixed(2));
                setTableRowState(prevState => {
                    return { ...prevState, "riskWithIntervention": riskWithIntervention };
                });
            }
        }
        if (!isNaN(tableRowState.numberAffectedComparator) &&
            !isNaN(tableRowState.numberAnalyzedComparator)) {
            let riskWithComparator = tableRowState.numberAffectedComparator / tableRowState.numberAnalyzedComparator;
            if (!isNaN(riskWithComparator)) {
                riskWithComparator = parseFloat((riskWithComparator * 100).toFixed(2));
                setTableRowState(prevState => {
                    return { ...prevState, "riskWithComparator": riskWithComparator };
                });
            }
        }
    }, [
        tableRowState.numberAffectedIntervention, tableRowState.numberAnalyzedIntervention,
        tableRowState.numberAffectedComparator, tableRowState.numberAnalyzedComparator
    ]);

    useEffect(() => {
        if (Object.keys(tableRowState).length > 0) {
            let newRow = {
                "outcomeName": "",
                "desirable": false,
                "DIO": false,
                "observedOutcomeReference": "",
                "intendedOutcomeReference": "",
                "numberAffectedIntervention": NaN,
                "numberAnalyzedIntervention": NaN,
                "riskWithIntervention": NaN,
                "numberAffectedComparator": NaN,
                "numberAnalyzedComparator": NaN,
                "riskWithComparator": NaN,
                "effectEstimateType": "",
                "effectEstimateValue": NaN,
                "lowerCI": NaN,
                "upperCI": NaN,
                "certainty": ""
            };
            if (tableRowState.outcomeName) {
                newRow.outcomeName = tableRowState.outcomeName;
            }
            if (tableRowState.desirable) {
                newRow.desirable = tableRowState.desirable;
            }
            if (tableRowState.DIO) {
                newRow.DIO = tableRowState.DIO;
            }
            if (tableRowState.observedOutcomeReference) {
                newRow.observedOutcomeReference = tableRowState.observedOutcomeReference;
            }
            if (tableRowState.intendedOutcomeReference) {
                newRow.intendedOutcomeReference = tableRowState.intendedOutcomeReference;
            }
            if (tableRowState.effectEstimateType) {
                newRow.effectEstimateType = tableRowState.effectEstimateType;
            }
            if (!isNaN(tableRowState.numberAffectedIntervention)) {
                newRow.numberAffectedIntervention = tableRowState.numberAffectedIntervention;
            }
            if (!isNaN(tableRowState.numberAnalyzedIntervention)) {
                newRow.numberAnalyzedIntervention = tableRowState.numberAnalyzedIntervention;
            }
            if (!isNaN(tableRowState.riskWithIntervention)) {
                newRow.riskWithIntervention = tableRowState.riskWithIntervention;
            }
            if (!isNaN(tableRowState.numberAffectedComparator)) {
                newRow.numberAffectedComparator = tableRowState.numberAffectedComparator;
            }
            if (!isNaN(tableRowState.numberAnalyzedComparator)) {
                newRow.numberAnalyzedComparator = tableRowState.numberAnalyzedComparator;
            }
            if (!isNaN(tableRowState.riskWithComparator)) {
                newRow.riskWithComparator = tableRowState.riskWithComparator;
            }
            if (!isNaN(tableRowState.effectEstimateValue)) {
                newRow.effectEstimateValue = tableRowState.effectEstimateValue;
            }
            if (!isNaN(tableRowState.lowerCI)) {
                newRow.lowerCI = tableRowState.lowerCI;
            }
            if (!isNaN(tableRowState.upperCI)) {
                newRow.upperCI = tableRowState.upperCI;
            }
            if (tableRowState.certainty) {
                newRow.certainty = tableRowState.certainty;
            }
            setTableState(prevState => {
                let newTable = prevState;
                newTable[rowIndex] = newRow;
                return newTable;
            })
        }
    }, [tableRowState])

    return <>
        <Table.Cell style={{ verticalAlign: "top" }}>
            <StringEntry elementName='outcomeName' fieldLabel='Outcome Name'
                startingValue={tableRowState.outcomeName}
                setResourceState={setTableRowState} />
            <BooleanEntry elementName="desirable" fieldLabel='Desirable'
                startingValue={tableRowState.desirable ? true : false}
                setResourceState={setTableRowState} />
            <BooleanEntry elementName="DIO" fieldLabel='Create new DIO'
                startingValue={tableRowState.DIO ? true : false}
                setResourceState={setTableRowState} />
            <ReferenceEntry elementName='observedOutcomeReference' fieldLabel='Observed Outcome Reference'
                startingValue={tableRowState.observedOutcomeReference}
                startingResourceType="EvidenceVariable"
                referencedResourceTypes={["EvidenceVariable"]}
                enableCreation={true}
                setProfile={"VariableDefinition"}
                setResourceState={setTableRowState} />
            <ReferenceEntry elementName='intendedOutcomeReference' fieldLabel='Intended Outcome Reference'
                startingValue={tableRowState.intendedOutcomeReference}
                startingResourceType="EvidenceVariable"
                referencedResourceTypes={["EvidenceVariable"]}
                enableCreation={true}
                setProfile={"DichotomousIntendedOutcome"}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top" }}>
            <UnsignedIntEntry elementName='numberAffectedIntervention' fieldLabel='Number Affected (Intervention)'
                startingValue={tableRowState.numberAffectedIntervention}
                setResourceState={setTableRowState} />
            <PositiveIntEntry elementName='numberAnalyzedIntervention' fieldLabel='Number Analyzed (Intervention)'
                startingValue={tableRowState.numberAnalyzedIntervention}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='riskWithIntervention' fieldLabel='Risk (%) with Intervention'
                startingValue={tableRowState.riskWithIntervention}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top", paddingLeft: "0px" }}>
            <UnsignedIntEntry elementName='numberAffectedComparator' fieldLabel='Number Affected (Comparator)'
                startingValue={tableRowState.numberAffectedComparator}
                setResourceState={setTableRowState} />
            <PositiveIntEntry elementName='numberAnalyzedComparator' fieldLabel='Number Analyzed (Comparator)'
                startingValue={tableRowState.numberAnalyzedComparator}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='riskWithComparator' fieldLabel='Risk (%) with Comparator'
                startingValue={tableRowState.riskWithComparator}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top", whiteSpace: "pre-wrap" }}>
            <CodeEntry elementName='effectEstimateType' fieldLabel='Effect Estimate Type'
                startingValue={tableRowState.effectEstimateType} setResourceState={setTableRowState}
                dataEntryStyle='dropdown' inTableCell={true}
                allowedValues={['risk difference', 'risk ratio', 'odds ratio']} />
            <DecimalEntry elementName='effectEstimateValue' fieldLabel='Effect Estimate (% if risk difference)'
                startingValue={tableRowState.effectEstimateValue}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ align: "center", padding: "0px" }}>
            <DecimalEntry elementName='lowerCI' fieldLabel='Lower Bound (95% CI)'
                startingValue={tableRowState.lowerCI}
                setResourceState={setTableRowState} />
            <DecimalEntry elementName='upperCI' fieldLabel='Upper Bound (95% CI)'
                startingValue={tableRowState.upperCI}
                setResourceState={setTableRowState} />
        </Table.Cell>
        <Table.Cell style={{ verticalAlign: "top" }}>
            <CodeableConceptEntry elementName='certainty' fieldLabel='Certainty of evidence'
                startingValue={tableRowState.certainty}
                codeableConceptLevelValueSet={overallCertaintyRatingValueSet}
                setResourceState={setTableRowState} />
        </Table.Cell>
    </>
}

// eslint-disable-next-line no-empty-pattern
const CreateComparativeEvidenceSynthesisReport = ({ }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [groupReferencesState, setGroupReferencesState] = useState({
        "populationName": "", "interventionName": "", "comparatorName": ""
    });
    const [introductionState, setIntroductionState] = useState({
        "title": "", "netBenefitCalculatorIntroduction": "",
        "sourceIntroduction": "", "sourceCitation": "",
        "netBenefitCalculatorWhat": "", "netBenefitCalculatorForWhom": "",
        "netBenefitCalculatorSource": ""
    });
    const [tableState, setTableState] = useState([]);
    const [jsonEditingState, setJsonEditingState] = useState({ "jsonView": false });
    const [picoClassifiersState, setPicoClassifiersState] = useState({
        populationArray: [],
        interventionArray: [],
        comparatorArray: [],
        outcomeArray: []
    });

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {apiToken ?
                <>{jsonEditingState.jsonView ?
                    <div>
                        <TextArea style={{ minHeight: "400px", width: "65%" }}
                            value={jsonEditingState.fhirEntryStringRevised ||
                                (jsonEditingState.jsonString &&
                                    JSON.stringify(JSON.parse(jsonEditingState.jsonString), null, 2)) || ''}
                            onChange={(e) => {
                                setJsonEditingState(prevState => {
                                    return {
                                        ...prevState,
                                        "fhirEntryStringRevised": e.target.value
                                    }
                                });
                            }} />
                        <br />
                        <Button className="formButton positive" content="Submit" compact
                            onClick={() => {
                                try {
                                    let jsonString = jsonEditingState.fhirEntryStringRevised || jsonEditingState.jsonString;
                                    let json = JSON.parse(jsonString);
                                    submitResources(apiToken, navigate, json.results, json.groupings, dispatch, json.introduction, json.picoClassifiers);
                                } catch {
                                    alert("Unable to process the JSON.");
                                }
                            }} />
                        &nbsp;&nbsp;&nbsp;
                        <Button className="formButton" content="Edit Text View" compact
                            onClick={() => {
                                try {
                                    let jsonString = jsonEditingState.fhirEntryStringRevised || jsonEditingState.jsonString;
                                    let json = JSON.parse(jsonString);
                                    setIntroductionState(json.introduction);
                                    setGroupReferencesState(json.groupings);
                                    setTableState(json.results);
                                    setPicoClassifiersState(json.picoClassifiers);
                                    setJsonEditingState({ "jsonView": false })
                                } catch {
                                    alert("Unable to process the JSON.");
                                }
                            }} />
                    </div>
                    :
                    <div>
                        <StringEntry elementName='title' fieldLabel='Title'
                            startingValue={introductionState.title}
                            setResourceState={setIntroductionState} />
                        <StringEntry elementName='sourceCitation' fieldLabel='Source Citation'
                            startingValue={introductionState.sourceCitation}
                            setResourceState={setIntroductionState} />
                        <StringEntry elementName='sourceIntroduction' fieldLabel='Source Introduction'
                            startingValue={introductionState.sourceIntroduction}
                            setResourceState={setIntroductionState} />
                        <StringEntry elementName='populationName' fieldLabel='Population'
                            startingValue={groupReferencesState.populationName}
                            setResourceState={setGroupReferencesState} />
                        <StringEntry elementName='interventionName' fieldLabel='Intervention'
                            startingValue={groupReferencesState.interventionName}
                            setResourceState={setGroupReferencesState} />
                        <StringEntry elementName='comparatorName' fieldLabel='Comparator'
                            startingValue={groupReferencesState.comparatorName}
                            setResourceState={setGroupReferencesState} />
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Outcome</Table.HeaderCell>
                                    <Table.HeaderCell>Rate with Intervention</Table.HeaderCell>
                                    <Table.HeaderCell>Rate with Comparator</Table.HeaderCell>
                                    <Table.HeaderCell>Effect Estimate</Table.HeaderCell>
                                    <Table.HeaderCell>95% Confidence Interval</Table.HeaderCell>
                                    <Table.HeaderCell>Certainty</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {tableState?.length > 0 ?
                                    tableState.map((row, rowIndex) => {
                                        return <Table.Row key={rowIndex}>
                                            <TableRowEntry row={row} setTableState={setTableState}
                                                rowIndex={rowIndex} />
                                        </Table.Row>
                                    })
                                    :
                                    <Table.Row>
                                        <Table.Cell colSpan="6" style={{ textAlign: "center" }}>
                                            <h4>There are no table rows created yet.</h4>
                                        </Table.Cell>
                                    </Table.Row>
                                }
                                <Table.Row>
                                    <Table.Cell colSpan="6" style={{ textAlign: "right" }}>
                                        <Button className="formButton" content="Add Table Row"
                                            style={{ color: "#000000" }} compact
                                            onClick={() => {
                                                setTableState(prevState => {
                                                    return [...prevState, {
                                                        "outcomeName": "",
                                                        "desirable": false,
                                                        "DIO": false,
                                                        "observedOutcomeReference": "",
                                                        "intendedOutcomeReference": "",
                                                        "numberAffectedIntervention": NaN,
                                                        "numberAnalyzedIntervention": NaN,
                                                        "riskWithIntervention": NaN,
                                                        "numberAffectedComparator": NaN,
                                                        "numberAnalyzedComparator": NaN,
                                                        "riskWithComparator": NaN,
                                                        "effectEstimateType": "",
                                                        "effectEstimateValue": NaN,
                                                        "lowerCI": NaN,
                                                        "upperCI": NaN,
                                                        "certainty": ""
                                                    }]
                                                });
                                            }} />
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <br />
                        <h4>An introduction for use with the Net Benefit Calculator</h4>
                        <h5>Optional text presented before the structured introduction</h5>
                        <MarkdownEntry elementName='netBenefitCalculatorIntroduction'
                            fieldLabel='Net Benefit Calculator introduction (additional text)'
                            startingValue={introductionState.netBenefitCalculatorIntroduction}
                            setResourceState={setIntroductionState} />
                        <h5>This Net Benefit Calculator is prepared to help you decide whether or not to ...</h5>
                        <MarkdownEntry elementName='netBenefitCalculatorWhat'
                            fieldLabel='Net Benefit Calculator introduction (What)'
                            startingValue={introductionState.netBenefitCalculatorWhat}
                            setResourceState={setIntroductionState} />
                        <h5>The estimated benefits and harms are for people who have ...</h5>
                        <MarkdownEntry elementName='netBenefitCalculatorForWhom'
                            fieldLabel='Net Benefit Calculator introduction (For Whom)'
                            startingValue={introductionState.netBenefitCalculatorForWhom}
                            setResourceState={setIntroductionState} />
                        <h5>The evidence to estimate the benefits and harms comes from ...</h5>
                        <MarkdownEntry elementName='netBenefitCalculatorSource'
                            fieldLabel='Net Benefit Calculator introduction (Source)'
                            startingValue={introductionState.netBenefitCalculatorSource}
                            setResourceState={setIntroductionState} />
                        <h4>Classify the Population</h4>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='populationArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Condition' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.populationArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <h4>Classify the Intervention</h4>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='interventionArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Intervention' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.interventionArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <h4>Classify the Comparator</h4>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='comparatorArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Comparator' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.comparatorArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <h4>Classify the Outcome(s)</h4>
                        <ArrayEntry datatype="CodeableConcept"
                            elementName='outcomeArray'
                            systemChoices={systemChoices} systemChoicesOpen={true}
                            fieldLabel='Outcome' startCollapsed={true} startEmptyArrayClosed={true}
                            startingValue={picoClassifiersState.outcomeArray || []}
                            setResourceState={setPicoClassifiersState} />
                        <br />
                        <Button className="formButton positive" content="Submit" compact
                            onClick={() => {
                                submitResources(apiToken, navigate, tableState, groupReferencesState, dispatch, introductionState, picoClassifiersState);
                            }} />
                        &nbsp;&nbsp;&nbsp;
                        <Button className="formButton" content="Edit JSON" compact
                            onClick={() => {
                                setJsonEditingState({
                                    "jsonView": true,
                                    "jsonString": JSON.stringify({
                                        "introduction": introductionState,
                                        "groupings": groupReferencesState,
                                        "results": tableState,
                                        "picoClassifiers": picoClassifiersState
                                    })
                                });
                            }} />
                    </div>
                }</>
                :
                <div>
                    <h1>Please log in to use this function.</h1>
                </div>
            }
        </Segment>
    </div>
};

export default CreateComparativeEvidenceSynthesisReport;